import CoursewareTargetProvider from '../coursewareTarget/CoursewareTargetProvider';

export default async function expandSimplifiedTarget(simplifiedTarget) {
  const simplifiedAncestry = simplifiedTarget.simplifiedAncestry || [];

  if (!simplifiedTarget.id) {
    return simplifiedTarget;
  }

  // Fetch the parents first (ordered by activity > interactive > component) so we
  // have everything we need (types and ancestry) before finding the final target.
  if (simplifiedAncestry[0]) {
    await CoursewareTargetProvider.createCoursewareTarget(simplifiedAncestry[0]);
  }
  if (simplifiedAncestry[1]) {
    await CoursewareTargetProvider.createCoursewareTarget(simplifiedAncestry[1]);
  }

  const target = await CoursewareTargetProvider.createCoursewareTarget(simplifiedTarget.id);

  return {
    ...target,
    subTarget: simplifiedTarget.subTarget,
  };
}
